module.exports = __webpack_public_path__ + "static/7-d8d1b1369e34143400981051e25759b2.jpg";